import { AuthguardGuard } from './shared/authguard.guard';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [

  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'product',
    loadChildren: () => import('./product/product.module').then(m => m.ProductPageModule)
  },
  {
    path: 'order-detail',
    loadChildren: () => import('./order-detail/order-detail.module').then( m => m.OrderDetailPageModule)
  },
  {
    path: 'suivre-commande',
    loadChildren: () => import('./order-detail/order-detail.module').then( m => m.OrderDetailPageModule)
  },
  {
    path: 'produits',
    loadChildren: () => import('./product/product.module').then(m => m.ProductPageModule)
  },
  {
    path: 'shop',
    loadChildren: () => import('./category/category.module').then(m => m.CategoryPageModule)
  },

  {
    path: 'shop/:slug',
    loadChildren: () => import('./child-category/child-category.module').then(m => m.ChildCategoryPageModule)
  },
  {
    path: 'boutique/:slug',
    loadChildren: () => import('./child-category/child-category.module').then(m => m.ChildCategoryPageModule)
  },

  {
    path: 'shop/:category_slug/products',
    loadChildren: () => import('./product/product.module').then(m => m.ProductPageModule)
  },
  {
    path: 'boutique/:category_slug',
    loadChildren: () => import('./product/product.module').then(m => m.ProductPageModule)
  },

  {
    path: 'shop/product/:slug',
    loadChildren: () => import('./m-product-detail/m-product-detail.module').then(m => m.MProductDetailPageModule)
  },
  {
    path: 'boutique/produit/:slug',
    loadChildren: () => import('./m-product-detail/m-product-detail.module').then(m => m.MProductDetailPageModule)
  },

  {
    path: 'cart',
    loadChildren: () => import('./cart/cart.module').then(m => m.CartPageModule)
  },
  {
    path: 'panier',
    loadChildren: () => import('./cart/cart.module').then(m => m.CartPageModule)
  },
  {
    path: 'cart/:cart_slug',
    loadChildren: () => import('./cart/cart.module').then(m => m.CartPageModule)
  }
  ,
  {
    path: 'panier/:cart_slug',
    loadChildren: () => import('./cart/cart.module').then(m => m.CartPageModule)
  }
  ,
  {
    path: 'wish',
    loadChildren: () => import('./wish/wish.module').then(m => m.WishPageModule)
  },
  {
    path: 'liste-de-souhaits',
    loadChildren: () => import('./wish/wish.module').then(m => m.WishPageModule)
  },
  {
    path: 'profil/modification',
    loadChildren: () => import('./profile-edit/profile-edit.module').then(m => m.ProfileEditPageModule)
  },
  {
    path: 'profile/edit',
    loadChildren: () => import('./profile-edit/profile-edit.module').then(m => m.ProfileEditPageModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('./order/order.module').then(m => m.OrderPageModule)
  },
  {
    path: 'commandes',
    loadChildren: () => import('./order/order.module').then(m => m.OrderPageModule)
  },

  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'profil',
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'search/:search',
    loadChildren: () => import('./search/search.module').then(m => m.SearchPageModule)
  },
  {
    path: 'recherche/:search',
    loadChildren: () => import('./search/search.module').then(m => m.SearchPageModule)
  },
  {
    path: 'boutique',
    loadChildren: () => import('./category/category.module').then(m => m.CategoryPageModule)
  },

  {
    path: 'register',
    loadChildren: () => import('./account/account.module').then(m => m.AccountPageModule),
    canActivate: [AuthguardGuard]
  },
  {
    path: 'creer-un-compte',
    loadChildren: () => import('./account/account.module').then(m => m.AccountPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./account/account.module').then(m => m.AccountPageModule),
    canActivate: [AuthguardGuard]
  },
  {
    path: 'se-connecter',
    loadChildren: () => import('./account/account.module').then(m => m.AccountPageModule),
    canActivate: [AuthguardGuard]
  },
  {
    path: '#login-old',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule),
    canActivate: [AuthguardGuard]
  },
  {
    path: '#register-old',
    loadChildren: () => import('./register/register.module').then(m => m.RegisterPageModule),
    canActivate: [AuthguardGuard]
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule),
    canActivate: [AuthguardGuard]
  },
  {
    path: 'mot-de-passe-oublie',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule),
    canActivate: [AuthguardGuard]
  },
  {
    path: 'verify-account',
    loadChildren: () => import('./verify-account/verify-account.module').then(m => m.VerifyAccountPageModule),
    canActivate: [AuthguardGuard]
  },
  {
    path: 'verifier-compte',
    loadChildren: () => import('./verify-account/verify-account.module').then(m => m.VerifyAccountPageModule),
    canActivate: [AuthguardGuard]
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordPageModule),
    canActivate: [AuthguardGuard]
  },
  {
    path: 'reinitialiser-le-mot-de-passe',
    loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordPageModule),
    canActivate: [AuthguardGuard]
  },


  {
    path: 'blogs',
    loadChildren: () => import('./blog-categories/blog-categories.module').then(m => m.BlogCategoriesPageModule)
  },
  // {
  //   path: 'blogs',
  //   loadChildren: () => import('./blog-categories/blog-categories.module').then(m => m.BlogCategoriesPageModule)
  // },

  {
    path: 'blogs/:slug',
    loadChildren: () => import('./blog/blog.module').then(m => m.BlogPageModule)
  },
  // {
  //   path: 'blogs/:slug',
  //   loadChildren: () => import('./blog/blog.module').then(m => m.BlogPageModule)
  // },

  {
    path: 'blogs/:categorie_slug/:id',
    loadChildren: () => import('./blog-detail/blog-detail.module').then(m => m.BlogDetailPageModule)
  },

  // {
  //   path: 'blogs/:categorie_slug/:id',
  //   loadChildren: () => import('./blog-detail/blog-detail.module').then(m => m.BlogDetailPageModule)
  // },

  {
    path: 'order-validate',
    loadChildren: () => import('./order-validate/order-validate.module').then(m => m.OrderValidatePageModule)
  },

  {
    path: 'validation-de-la-commande',
    loadChildren: () => import('./order-validate/order-validate.module').then(m => m.OrderValidatePageModule)
  },

  {
    path: 'make-notice',
    loadChildren: () => import('./make-notice-product/make-notice-product.module').then(m => m.MakeNoticeProductPageModule)
  },
  {
    path: 'noter-l-article',
    loadChildren: () => import('./make-notice-product/make-notice-product.module').then(m => m.MakeNoticeProductPageModule)
  },
  {
    path: 'partners',
    loadChildren: () => import('./partner/partner.module').then(m => m.PartnerPageModule)
  },
  {
    path: 'partners/:slug',
    loadChildren: () => import('./partner-detail/partner-detail.module').then(m => m.PartnerDetailPageModule)
  },
  {
    path: 'partenaires',
    loadChildren: () => import('./partner/partner.module').then(m => m.PartnerPageModule)
  },
  {
    path: 'partenaires/:slug',
    loadChildren: () => import('./partner-detail/partner-detail.module').then(m => m.PartnerDetailPageModule)
  },
  // {
  //   path: 'categories/:slug',
  //   loadChildren: () => import('./child-category/child-category.module').then(m => m.ChildCategoryPageModule)
  // },
  {
    path: 'product-single-widget',
    loadChildren: () => import('./widgets/product-single-widget/product-single-widget.module').then(m => m.ProductSingleWidgetPageModule)
  },
  {
    path: 'vendors',
    loadChildren: () => import('./vendors/vendors.module').then(m => m.VendorsPageModule)
  },
  {
    path: 'rescues',
    loadChildren: () => import('./rescues/rescues.module').then(m => m.RescuesPageModule)
  },
  {
    path: 'our-story/rescues/:slug',
    loadChildren: () => import('./rescues/rescues.module').then(m => m.RescuesPageModule)
  },
  {
    path: 'notre-histoire/rescapes/:slug',
    loadChildren: () => import('./rescues/rescues.module').then(m => m.RescuesPageModule)
  },
  {
    path: 'refresh',
    loadChildren: () => import('./component/refresh/refresh.module').then(m => m.RefreshPageModule)
  },
  {
    path: 'network',
    loadChildren: () => import('./component/network/network.module').then(m => m.NetworkPageModule)
  },
  {
    path: 'verify-token-newletter/:token',
    loadChildren: () => import('./newsletter-verify/newsletter-verify.module').then(m => m.NewsletterVerifyPageModule)
  },

  {
    path: 'newsletter',
    loadChildren: () => import('./newsletter-form/newsletter-form.module').then(m => m.NewsletterFormPageModule)
  },

  {
    path: 'infolettre',
    loadChildren: () => import('./newsletter-form/newsletter-form.module').then(m => m.NewsletterFormPageModule)
  },

  {
    path: 'notre-histoire',
    loadChildren: () => import('./notre-histoire/notre-histoire.module').then(m => m.NotreHistoirePageModule)
  },
  {
    path: 'our-story',
    loadChildren: () => import('./notre-histoire/notre-histoire.module').then(m => m.NotreHistoirePageModule)
  },
  {
    path: 'blogs',
    redirectTo: '/blog-categories',
    pathMatch: 'full'
  },
  {
    path: ':slug',
    loadChildren: () => import('./page/page.module').then(m => m.PagePageModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./component/menu/menu.module').then(m => m.MenuPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./layout/main/main.module').then(m => m.MainPageModule)
  },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  },

  {
    path: 'blog-single-widget',
    loadChildren: () => import('./widgets/blog-single-widget/blog-single-widget.module').then(m => m.BlogSingleWidgetPageModule)
  },


  {
    path: 'image-modal',
    loadChildren: () => import('./image-modal/image-modal.module').then(m => m.ImageModalPageModule)
  }



];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
